module.exports = __webpack_public_path__ + "assets/space-object-a6126617977d6e2182a6e1bb13526d3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/space-object.jpg
// module id = 524
// module chunks = 1